import Plyr from "plyr";
import Hls from "hls.js/dist/hls.light.min";
import {videoAutoplayCheck} from "./video-autoplay-check";

interface VideoHlsOptions {

    /**
     * loop
     *
     * */
    loop?: boolean;

    /**
     * muted
     *
     * */
    muted?: boolean;

    /**
     * autoplay
     *
     * */
    autoplay?: boolean;

    /**
     * on init
     *
     * */
    onPlayStart?: (videoHls: VideoHls) => any;

    /**
     * on ended
     * loop: false
     *
     * */
    onEnded?: (videoHls: VideoHls) => any;
}

const VideoHlsDefaultOptions: VideoHlsOptions = {
    onPlayStart: null,
    onEnded: null,
    loop: true,
    muted: true,
    autoplay: true
}

class VideoHls {

    protected container: HTMLElement
    protected video: HTMLVideoElement
    //protected poster: HTMLImageElement
    public player: Plyr
    protected src = 'https://video.platformcraft.ru/vod/URL/playlist.m3u8';
    protected options;


    constructor(container: HTMLElement, options?: VideoHlsOptions) {

        this.options = {...VideoHlsDefaultOptions, ...options};

        if (!videoAutoplayCheck.allow)
            return;

        this.container = container;

        this.video = document.createElement('video');
        this.container.appendChild(this.video);

        if (typeof this.container.dataset.video !== 'undefined') {
            this.src = this.container.dataset.video;
        } else {
            if (typeof this.container.dataset.id === 'undefined')
                return;

            this.src = this.src.replace('URL', this.container.dataset.id);
        }

        this.player = new Plyr(this.video, {
            debug: false,
            muted: this.options.muted,
            autoplay: this.options.autoplay,
            controls: [],
            fullscreen: {
                iosNative: true
            }
        });

        this.player.once('canplay', this.onCanPlay.bind(this))

        if (!Hls.isSupported()) {
            this.video.src = this.src;
        } else {
            const hls = new Hls();
            hls.loadSource(this.src);
            hls.attachMedia(this.video);
        }

        // @ts-ignore
        this.video.playsInline = true;
        this.video.muted = this.options.muted;
        this.video.loop = this.options.loop;
        this.video.autoplay = this.options.autoplay;

        this.video.onended = () => {
            if (this.options.onEnded)
                this.options.onEnded(this)
        };
    }

    onCanPlay(event) {
        this.container.classList.add('loaded');
        if (this.options.onPlayStart)
            this.options.onPlayStart(this)
    }

    destroy() {
        this.player.destroy()
    }

}

export default VideoHls;
